
$(document).ready(function(){
  var isiPad = navigator.userAgent.toLowerCase().indexOf("ipad");
  if(isiPad > -1) {
	$('a:not(.participate):not(.close)').click(function(event){
        event.preventDefault();
        window.location.assign($(this).attr('href'));
        return false;
    });

  }

	$(".burger-menu").click(function () {
		$(this).toggleClass("menu-on");
		$('body').toggleClass("open");
	});

// SCROLL TO ID & #REMOVAL

	$(function() {
	  $('a[href*="#"]:not([href="#"])').click(function() {
	    if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
	      var target = $(this.hash);
	      target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
	      if (target.length) {
	        $('html, body').animate({
	          scrollTop: target.offset().top
	        }, 1500);
	        return false;
	      }
	    }
	  });
	});

	$('.menu-toggle').click(function () {

	    $(this).parent().toggleClass('opened');

	    if ($(this).parent().hasClass('opened')) {
	        $(this).html('×');
	    } else {
	        $(this).html('☰');
	    }

	    return false;

	});

	// PARTICIPATE
	
	if(isiPad > -1) {
		$('.participate').click(function (evt) {
	
			evt.preventDefault();
	
			$('.modal-participate').fadeIn(300);
			
			return false;
		});
	}

	$('.modal-participate a.close').click(function (evt) {

		evt.preventDefault();

		$('.modal-participate').fadeOut(300);
		
		return false;
	});

	// MENU 

	$(".toggle p").click(function (evt) {
		
	    evt.preventDefault();

	    //if ($(window).width() > 480) {
	   
		    if($('.toggle ul').is(':visible')){
		        $('.toggle ul').slideUp(300);
		        $('.toggle').removeClass('down');
		    }
		    
		    else {
		        $('.toggle ul').slideDown(300);
		        $('.toggle').addClass('down');
		    }
		//}
		
		return false;
	});

	function historyChanged (url) {
		switch (true) {
			case url.indexOf('/poeles') > -1 :
			case url.indexOf('/inserts') > -1 :
				$('.back-arrow').fadeIn();
				break;

			default :
				$('.back-arrow').fadeOut();
		}
	}
	$('.navigator li:first-of-type').click(function () {
		$('.slider').backstretch("show", 0);
		$(this).addClass("show");
	    
	});
	$('.navigator li:not(:first-of-type):not(:last-of-type)').click(function () {
	    $('.slider').backstretch("show", 1); 
	});
	$('.navigator li:last-of-type').click(function () {
	    $('.slider').backstretch("show", 2); 
	});


});

$(document).ready(function() {
	$("form").submit(function() {
		$('body').addClass('submited');
	}); 
	
	$(".countries").get(0).addEventListener('touchend', function(e){
		$(".countries").toggleClass('touched');	
	});
}); 






// GDPR MODAL - COOKIE BAR 

$('.btn-choice ').click(function() {
  	$(this).parents('.category').toggleClass('active');
});


$('.cookie_infos').click(function() {
	console.log(this, $('.modal-gdpr'));
  	$(".modal-gdpr").addClass("show");
  	return false;
});

$('.close').click(function() {
  	$(".modal-gdpr").removeClass("show");
});


$('.open-cookie').click(function() {
  	$(".cookie-bar").removeClass("noshow");
  	return false;
});

var gdprGetParams = {};
$('.accept_cookie').click(function() {
  	$(".cookie-bar").addClass("noshow");
  	
	setCookie('_gdpr-settings', JSON.stringify(gdprGetParams) );

  	$.get( "/views/partials/analytics.php" , gdprGetParams, function(scripts){
  		$("body").append(scripts)
  	} ,"html"  );
  	
  	return false;
});

var setCookie = function(name, value) {
    var d = new Date;
    d.setTime(d.getTime() + (20 * 365 * 24 * 60 * 60));
    document.cookie = name + "=" + value + ";path=/;expires=" + d.toGMTString();
}

$('.btn-save').click(function(){
		
		var categories = $('.category.active');
		categories.each(function(){
			var track = $(this).data('tracking');
			gdprGetParams[track] = 1;
		});
		
		$(".modal-gdpr").removeClass("show");

		return false;
});





















